/* PACKAGES */
import { motion } from "framer-motion";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* ICONS */
import { GoArrowUpRight } from "react-icons/go";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

/* YOUTUBE TILE */
const YoutubeTile = (props) => {
  return (
    <a href={props.link} target="_blank" rel="noreferrer">
      <div className="group w-full border border-greyBorder rounded-md p-2 relative shadow-md hover:shadow-lg transition-all duration-300 ease-in-out">
        <img
          src={props.image}
          className="w-full h-auto object-contain rounded"
          alt={props.title}
        />

        {/* VIDEO TITLE */}
        <div className="!absolute bottom-0 left-0 bg-white rounded shadow-lg py-3 px-5 m-3">
          <h5 className="text-xl font-fraunces-bold tracking-tight text-black leading-snug">
            {props.title}
          </h5>
        </div>

        {/* ARROW */}
        <Button className="!absolute top-3 right-3 p-3 rounded-full bg-white group-hover:bg-primaryRed transition-all duration-300 ease-in-out shadow-lg text-black">
          <GoArrowUpRight className="w-5 h-5" />
        </Button>
      </div>
    </a>
  );
};

const PressMedia = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white"
    >
      {/* TOP ROW */}
      <motion.div variants={animation} className="py-6 xl:py-14 lg:py-14">
        <div className="container">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-5 xl:gap-20 lg:gap-20 items-center">
            <div className="col-span-1">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/TBOP7PTA9dU?si=KWO90X9JHaSmow_p"
                className="w-full h-[40vh] rounded-lg"
                title="Welcome to Food Farmacy"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
            <div className="col-span-1">
              <h5 className="text-3xl xl:text-3xl lg:text-3xl font-fraunces-black tracking-tight text-black">
                Food Farmacy's Press and Media
              </h5>
              <div className="mt-5">
                <p className="text-xl font-source font-normal text-textGrey tracking-tight">
                  We are Gujarat's 1<sup>st</sup> Healthy Food store Located in
                  Ahmedabad, off gurukul road. We have wide variety of sugar
                  free and preservative free products that serves for health
                  conscious individual. We have 100+ healthy brands under one
                  roof for retail experience with sampling options.
                </p>
              </div>
              <div className="mt-5">
                <p className="text-xl font-source font-normal text-textGrey tracking-tight">
                  Discover the buzz surrounding Food Farmacy! Explore our latest
                  press releases, media features, and exciting podcasts
                  showcasing our commitment to healthy living and sustainable
                  practices
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* SECOND ROW */}
      <motion.div variants={animation} className="py-6 xl:py-14 lg:py-14">
        <div className="container">
          <div className="border-b border-greyBorder pb-2">
            <h2 className="text-3xl xl:text-4xl lg:text-4xl font-fraunces-black tracking-tight">
              Our Podcasts
            </h2>
          </div>
          <div className="mt-5">
            <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-5 xl:gap-10 lg:gap-10">
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-01.jpg")}
                  title="Talk on Being Healthy and Fit with Dt. Komal Patel"
                  link="https://youtu.be/UMdegOgBomI?si=SdCuat_QjRGoEox0"
                />
              </div>
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-02.jpg")}
                  title="From Farm to Health with Professor Purvi Vyas"
                  link="https://youtu.be/USB3FzkJXbA?si=iMIeONLeCHIEtmFt"
                />
              </div>
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-03.jpg")}
                  title="Beyond the finish line with Dr. Bhaskar Thakkar"
                  link="https://youtu.be/oX3N9hs9VLc?si=GouS3EDgsyjEp1rr"
                />
              </div>
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-04.jpg")}
                  title="Talk on Endometriosis with Dr. Shailee Bhandari"
                  link="https://youtu.be/7kCDOyZnoS8?si=S8-5rozfsRE5dhfW"
                />
              </div>
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-05.jpg")}
                  title="How to improve your mental health?"
                  link="https://youtu.be/zYcGb0ClilE?si=WdBIYujzKtFmK4UY"
                />
              </div>
              <div className="col-span-1">
                <YoutubeTile
                  image={require("../../assets/images/press-media/video-05.jpg")}
                  title="How to improve your mental health?"
                  link="https://youtu.be/zYcGb0ClilE?si=WdBIYujzKtFmK4UY"
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default PressMedia;
